module.exports = __webpack_public_path__ + "media/cake-ify.a858bd41.webm";